import { useMemo, useState } from "react";
import { Button } from "reactstrap";

import AppFieldCard from "../../elements/AppFieldCard";
import useWorkspace from "../../api/api-hooks/workspaces/useWorkspace";
import AppDrawer from "./AppDrawer";
import useAddExistingPageToCloudApp from "../../api/api-hooks/cloudApps/useAddExistingPageToCloudApp";
import AppSpinner from "../../elements/AppSpinner";

interface AddExistingPageInCloudAppInterface {
  open: boolean;
  handleClose: () => void;
  appItem: any;
}

const AddExistingPageInCloudApp = ({
  open,
  handleClose,
  appItem,
}: AddExistingPageInCloudAppInterface) => {
  const { workspace } = useWorkspace();
  const [selectedPages, setSelectPage] = useState<string[]>([]);
  const {
    addPageToCloudApp,
    addPageToCloudAppSubmitting,
    addPageToCloudAppError,
  } = useAddExistingPageToCloudApp();

  const filteredSidebarItems = useMemo(() => {
    if (!appItem) return [];
    const sidebar: any[] = workspace?.Sidebar ?? [];
    const appPageIds = appItem?.Items.flatMap((item: any) => {
      if (item?.Type !== "PageLink") return [];

      return [item?.PageID];
    });

    return sidebar.filter((item) => {
      return (
        item?.Type === "PageLink" &&
        !appPageIds.includes(item?.PageID) &&
        item?.Privacy === "public"
      );
    });
  }, [workspace?.Sidebar?.length, appItem?.Items?.length]);

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      headerTitle="Add Existing Page"
      headerDescription={`Select a page to add it in ${appItem?.Name} Cloud App`}
      headerOptions={
        <Button
          size="sm"
          color="primary"
          onClick={() => {
            addExistingPage(appItem?.id);
          }}
          style={{ width: 80 }}
          disabled={!selectedPages.length || addPageToCloudAppSubmitting}
        >
          {addPageToCloudAppSubmitting ? (
            <AppSpinner size="sm" color="white" />
          ) : (
            "Add"
          )}
        </Button>
      }
      body={
        <>
          {filteredSidebarItems?.map((item) => {
            return (
              <AppFieldCard
                key={item.PageID}
                onClick={() => {
                  handleChange(item.PageID);
                }}
                isSelected={selectedPages.includes(item.PageID)}
                icon={
                  item?.IconURL
                    ? item?.IconURL
                    : "mdi mdi-file-table-box-outline"
                }
                name={item.Title}
                disabled={false}
                full={true}
                innerCSS="mx-1"
                css="mb-0"
                description=""
                vectorIcon={!!item?.IconURL}
              />
            );
          })}
        </>
      }
    />
  );

  function handleChange(pageID: string) {
    if (selectedPages.includes(pageID)) {
      // Removing page from the array
      const index = selectedPages.indexOf(pageID);
      if (index !== -1) {
        setSelectPage((prev) => prev.filter((pID) => pID !== pageID));
      }
    } else {
      // Adding page to the array
      setSelectPage((prev) => [...prev, pageID]);
    }
  }

  function handleSuccess() {
    setSelectPage([]);
    handleClose();
  }

  function addExistingPage(cloudAppID: string) {
    addPageToCloudApp({
      cloudAppID,
      payload: selectedPages,
      onSuccess: handleSuccess,
    });
  }
};

export default AddExistingPageInCloudApp;
